import moment from 'moment';
import React, { Component } from 'react';


class BasicInfo extends Component {

    render() {
        const { hospitalInstitutionsBasicInfo = {}, type } = this.props;
        const {
            recordNo,
            compName,
            compLevelStr,
            address,
            addressList,
            hospitalName,
            courtyardArea,
            linkMan,
            linkTel,
            initRecordTime,
            subDate,
            recordStatus,
        } = hospitalInstitutionsBasicInfo;
        const addressArr = (addressList || '').split(',');
        const addressShow = addressArr.map((value, index) => (
            <div key={index}>
                {value} 
            </div>
        ));
        return (
            <div className="modal-content" style={{ padding: '0 20px' }}>
                <ul className="modal-list">
                    <li className="modal-item">
                        <div className="item-left">备案号:</div>
                        <div className="item-right">{recordNo}</div>
                    </li>
                    <li className="modal-item">
                        <div className="item-left">机构名称:</div>
                        <div className="item-right">{compName}</div>
                    </li>
                    <li className="modal-item">
                        <div className="item-left">机构级别:</div>
                        <div className="item-right">{compLevelStr}</div>
                    </li>
                    <li className="modal-item">
                        <div className="item-left">地址:</div>
                        <div className="item-right">{address}</div>
                    </li>
                    {
                        addressList && <li className="modal-item">
                            <div className="item-left">其他机构地址:</div>
                            <div className="item-right">{addressShow}</div>
                        </li>
                    }
                    <li className="modal-item">
                        <div className="item-left">医院名称:</div>
                        <div className="item-right">{hospitalName}</div>
                    </li>
                    <li className="modal-item">
                        <div className="item-left">院区:</div>
                        <div className="item-right">{courtyardArea}</div>
                    </li>
                    <li className="modal-item">
                        <div className="item-left">联系人:</div>
                        <div className="item-right">{linkMan}</div>
                    </li>
                    <li className="modal-item">
                        <div className="item-left">联系方式:</div>
                        <div className="item-right">{linkTel}</div>
                    </li>
                    {
                        type == '02' &&
                            <li className="modal-item">
                                <div className="item-left">备案时间（首次）:</div>
                                <div className="item-right">{initRecordTime ? moment(initRecordTime).format('YYYY-MM-DD'): ''}</div>
                            </li>
                    }
                    <li className="modal-item">
                        <div className="item-left">备案时间:</div>
                        <div className="item-right">{subDate ? moment(subDate).format('YYYY-MM-DD'): ''}{initRecordTime !== subDate ? '（变更）' : ''}</div>
                    </li>
                    <li className="modal-item">
                        <div className="item-left">备案状态:</div>
                        <div className="item-right">{recordStatus ? recordStatus === '8' ? '已备案' : '取消备案' : ''}</div>
                    </li>
                </ul>
            </div>
        )
    }
}

export default BasicInfo;


// WEBPACK FOOTER //
// ./src/components/hospital/filingInfo/components/BasicInfo.js